import styled from 'styled-components'

const Table = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding: 12px;
  font-family: 'Inter';
  color: #2d3748;
`

const TableHeadContainer = styled.thead`
  font-size: 12px;
  line-height: 16px;
`

const TableBodyContainer = styled.tbody`
  font-size: 14px;
  line-height: 20px;
`

const TableHeader = styled.th`
  text-align: left;
  padding: 12px 24px;
`

const TableRow = styled.tr`
  background-color: #fcfcfc;

  &:nth-child(2n + 1) {
    background: #ffffff;
  }
`

const TableData = styled.td`
  border-top: 1px solid #e5e5e5;
  padding: 16px 24px;
`

export default Object.assign(Table, {
  THead: TableHeadContainer,
  TBody: TableBodyContainer,
  Header: TableHeader,
  Row: TableRow,
  Data: TableData,
})
